<template>
    <el-container>
        <el-header>
            <!-- 头部 -->
            <heardinformation />
        </el-header>
        <div>
            <!-- 主体 -->
            <router-view />
        </div>
        <el-footer>
            <!-- 底部 -->
            <information />
        </el-footer>
    </el-container>
</template>

<script>
import information from "../components/Footernavigation/Buttominformation";
import heardinformation from "../components/Heardnavigation/heardinformation";
import { Alls } from "../assets/js/global";
export default {
    components: {
        information,
        heardinformation,
    },
    metaInfo() {
        //设置浏览器标签页标题
        return {
            meta: [
                {
                    name: "baidu-site-verification",
                    content: "code-Ws7QX1wpbd",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.el-container {
    position: relative;
    .el-header {
        height: 68px;
        background: rgba(0, 0, 0, 1);
        // background: rgba(51, 51, 51, 1);
        box-shadow: 0px 0px 6px 0px rgba(51, 51, 51, 0.4);
    }
    .el-footer {
        width: 100%;
        min-height: 240px;
        background: rgba(51, 51, 51, 1);
    }
}
</style>
